import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { AuService } from '../au/au.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';

@Component({
  selector: 'app-activity-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  dateCustomClasses: DatepickerDateCustomClasses[];
  isProcessing: any = false;
  dataSource: any;
  searchValue = "";
  constructor(public dialog: MatDialog, private readonly appService: AppService, public paginationService: PaginationService,
    public qmsservice: qmsService, public message: messageService, public router: Router,
    public auService: AuService, private readonly sanitizer: DomSanitizer) {
  }
  timezone: any = "GMT";
  ngOnInit(): void {
    this.timezone = localStorage.getItem("timezone");
    if (this.timezone == "null") {
      this.timezone = "GMT"
    }
    if (this.qmsservice.activityId == null) {
      this.isProcessing = true;
      this.appService.getNotifications()
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.notificationsList = data;
          for (const element of this.notificationsList) {
            element.sentOn = this.convertTime(element.sentOn, this.timezone);
          }
          this.collectionSize = this.notificationsList.length;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
        })
    } else {
      this.isProcessing = true;
      this.appService.getNotificationForActivites(this.qmsservice.activityId)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.notificationsList = data;
          this.collectionSize = this.notificationsList.length;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
        })
    }
  }

  convertTime(date: any, timezone: any) {
    let dt = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: timezone }));
    let month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let hours = dt.getHours();
    let minutes: any = dt.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours || 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;

    return (("0" + dt.getDate()).slice(-2)) + "-" + ((month_names[(dt.getMonth())])) + "-" + (dt.getFullYear()) + " " + strTime;

  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  notificationsList: any;
  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;
  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.notificationsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.notificationsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.notificationsList) {
        element.childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (const element of this.notificationsList) {
        element.childCheckBoxs = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  htmlContent: any;
  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  popupDataTitle: any;
  addAndEditPopupConfig = {
    width: '100%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };
  openDetailPage(value: any) {
    this.isProcessing = true;
    this.htmlContent = "";
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    const htmlContent1 = document.getElementById("htmlContent") as HTMLInputElement;
    htmlContent1.innerHTML = "";
    this.popupDataTitle = "Content";
    this.appService.getMsgBodyDetails(value.notificationId)
      .subscribe((data: any) => {
        this.isProcessing = false;

        htmlContent1.innerHTML = data[0]?.messageBody;
      })
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }
}
